import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { EChartOption, ECharts } from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { BoxPlotLineService } from './box-plot-line.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { ChartResizeService } from '../../service/chart-resize.service';

@Component({
  selector: 'bcac-box-plot-line',
  templateUrl: './box-plot-line.component.html',
  styleUrls: ['./box-plot-line.component.scss']
})
export class BoxPlotLineComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private boxPlotLineService: BoxPlotLineService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService
  ) { }

  chartTitle = {
    show: true,
    label: "图表标题"
  };

  customToolbox = {
    show: true
  }

  // 布局设置
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = "";

  // echart图表元素
  chartBackgroundColor: string = "#FFF";
  chartColors: string[] = this.chartOptionService.getChartColors('default');
  chartTitles = this.chartOptionService.getChartTitle();
  chartLegend = this.chartOptionService.getChartLegend();
  chartGrid: EChartOption.Grid = this.commonService.changeFontSize().interval;
  chartxAxis: EChartOption.XAxis[] = this.boxPlotLineService.getChartxAxis(1);
  chartyAxis: EChartOption.YAxis[] = this.boxPlotLineService.getChartyAxis(2);
  chartTextStyle: EChartOption.TextStyle = this.chartOptionService.getTextStyle();
  boxPlotChartSeries: EChartOption.SeriesBoxplot = this.boxPlotLineService.getDefaultBoxPlotSeries();
  scatterChartSeries: EChartOption.Series = this.boxPlotLineService.getDefaultScatterSeries();
  lineChartSeries: EChartOption.Series = this.chartOptionService.getDefaultLineSeries();
  chartTooltip: EChartOption.Tooltip = this.boxPlotLineService.getBoxPlotTooltip();
  chartSeriesList: EChartOption.Series[] = [];

  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    title: this.chartTitle,
    legend: this.chartLegend,
    grid: this.chartGrid,
    xAxis: this.chartxAxis,
    yAxis: this.chartyAxis,
    series: this.chartSeriesList,
    tooltip: this.chartTooltip,
    color: this.chartColors,
    textStyle: this.chartTextStyle
  }

  initOpts = this.chartOptionService.getInitOpts();
  optionInit: ECharts;
  onOptionInit(ec) {
    this.optionInit = ec;
  }

  options;
  // echart配置项
  initEChart() {
    this.options = this.chartOption;
  }

  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.options, true)
    }
  }

  /* 
    接口去
  */
  //  暗色模式
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    this.boxPlotLineService.changeChartTitleDark(this, darkMode);
    this.boxPlotLineService.chartBackgroundColorDarkMode(this.chartOption);
    this.boxPlotLineService.xAxisDarkMode(this.chartxAxis);
    this.boxPlotLineService.yAxisDarkMode(this.chartyAxis);
    this.boxPlotLineService.colorsDarkMode(this.chartColors);
    this.boxPlotLineService.legendDarkMode(this.chartLegend);
    this.boxPlotLineService.seriesDarkMode(this.boxPlotChartSeries);
    this.boxPlotLineService.seriesDarkMode(this.lineChartSeries);
  }
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.boxPlotLineService.setSmallModeGrid(this.chartGrid)
      this.boxPlotLineService.setSmallModePadding(this);
    }
  }

  legendPosition = 'bottom';
  @Input()
  set bcacLegendPosition(legendPosition: string) {
    this.legendPosition = legendPosition;
    this.boxPlotLineService.setLegendPosition(this.chartGrid, this.chartLegend, legendPosition);
  }

  @Input()
  set bcacTitleSwith(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }

  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title
  }

  @Input()
  set bcacUnit(unit: string | string[]) {
    this.boxPlotLineService.setTooltipUnit(this.chartTooltip, unit);
  }

  @Input()
  set bcacXaxisName(xAxisName: string) {
    this.boxPlotLineService.setXaxisName(this.chartxAxis, xAxisName);
  }

  @Input()
  set bcacYaxisName(yAxisNames: string[]) {
    this.boxPlotLineService.setYaxisName(this.chartyAxis, yAxisNames)
  }

  @Input()
  set bcacYnameGap(yNameGap: number | number[]) {
    this.boxPlotLineService.setYNameGap(this.chartyAxis, yNameGap);
  }

  @Input()
  set bcacColors(colorList: string[]) {
    this.boxPlotLineService.chartColorsChange(this.chartColors, colorList);
  }


  @Input()
  set bcacAreaStyleSwith(areaStyleSwitch: boolean) {
    if (areaStyleSwitch) {
      this.lineChartSeries['areaStyle'] = {};
    }
  }

  @Input()
  set bcacIntervalData(value: any[]) {
    this.intervalData = value;
  }

  // 加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  @Input()
  set bcacDimensionNames(dimensionNames) {
    this.boxPlotLineService.setSeriesDimensionNames(this.boxPlotChartSeries, dimensionNames)
  }

  legendDataList;
  @Input()
  set bcacChartData(chartData: any) {
    let legendDataList = [];
    if (chartData.hasOwnProperty('seriesName')) {
      chartData.seriesName.forEach(seriesArr => {
        legendDataList.push({
          label: seriesArr,
          value: seriesArr,
          checked: true
        })
      });
    }
    this.legendDataList = legendDataList;
    this.boxPlotLineService.buildSeries(chartData, this.chartSeriesList, this.chartxAxis, this.boxPlotChartSeries, this.scatterChartSeries, this.lineChartSeries);
    this.updateOption();
  }

  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate) {
    this.boxPlotLineService.setXAxisLabelRotate(this.chartxAxis, xAxisLabelRotate)
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  legendChange($event) {
    this.boxPlotLineService.topLegendChange($event, this.optionInit);
  }


  @Input()
  set bcacYAxisLabelSplitSwitch(splitSwitch) {
    if (splitSwitch == false) {
      this.boxPlotLineService.changeYAxisLabelSplit(this.chartyAxis, splitSwitch)
    }
  }

  @Input()
  set bcacYAxisMin(yAxisMin: number[]) {
    this.boxPlotLineService.setYAxisMin(this.chartyAxis, yAxisMin)
  }

  @Input()
  set bcacYAxisMax(yAxisMax: number[]) {
    this.boxPlotLineService.setYAxisMax(this.chartyAxis, yAxisMax)
  }

  @Input()
  set bcacYAxisInterval(yAxisInterval: number[]) {
    this.boxPlotLineService.setYAxisInterval(this.chartyAxis, yAxisInterval)
  }

  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }


  // X轴刻度间隔
  intervalData = [];
  intervalSelectedData;
  intervalSelectedDataChange(e: any) {
    // 跟新图表interval
    this.boxPlotLineService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  axisScaleChange(e: any) {
    this.boxPlotLineService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  ngOnInit() {
    this.initEChart();
    this.updateOption();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.optionInit, this.options)
    })
  }

}
